/**
 * Loads the inspections application.
 * See the documentation here: https://single-spa.js.org/docs/configuration/#loading-function
 *
 * @param {boolean} isLocal True if the application is running in a local environment.
 * @returns {Promise<Module>} The single-spa inspections module.
 */
export const load = async (isLocal) => {
    return isLocal ?
        import(
            // ! this next line is a functional comment; removing it will break local environment loading
            /* webpackIgnore: true */
            "http://localhost:5180/src/main"
        )
    : System.import("@weever/flexDSM")
};
